document.addEventListener('DOMContentLoaded', function () {
  var video = document.getElementById('hero-perspective-video');
  var source = document.getElementById('hero-video-source');
  var buttons = document.querySelectorAll('.hero-perspective-btn');

  // Guard against missing elements
  if (!video || !source || !buttons.length) return;

  // Gather video URLs from buttons' data attributes or straight from Liquid (if you add data-src in Liquid for robustness)
  var videoUrls = {
    top: source.src, // Initial default
    mid: null,
    end: null
  };

  // Use the HTML markup to get correct sources for all perspectives
  buttons.forEach(function (btn) {
    var perspective = btn.getAttribute('data-perspective');
    // Look for the corresponding <source> in Liquid via data-attribute, OR fallback to create a mapping
    if (perspective === 'top') {
      videoUrls.top = source.src;
    } else if (perspective === 'mid') {
      videoUrls.mid = (typeof window.heroVideoMid !== 'undefined') ? window.heroVideoMid : '';
    } else if (perspective === 'end') {
      videoUrls.end = (typeof window.heroVideoEnd !== 'undefined') ? window.heroVideoEnd : '';
    }
  });

  // If you want to ensure video URLs are in data-src attributes, update buttons to use: <button ... data-src="{{ block.settings.video_mid | video_tag }}">
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Remove `.active` from all buttons
      buttons.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var perspective = btn.getAttribute('data-perspective');

      // Switch video
      var url = btn.getAttribute('data-src') || videoUrls[perspective];
      if (url && source.src !== url) {
        source.src = url;
        video.load();
        video.play();
      }
    });
  });
});
